import { Navigate, Route, Routes } from 'react-router-dom'

import Login from 'features/auth/login/Login'
import Channels from 'features/channels/Channels'
import Messages from 'features/messages/Messages'
import VideoCall from 'features/video-call/VideoCall'
import ProtectedMainLayout from './ProtectedMainLayout'
import Conversation from 'features/messages/Conversation'
import SystemSettings from 'features/settings/SystemSettings'
import ChannelsConversation from 'features/channels/Conversation'
import Dashboard from 'features/settings/dashboard/Dashboard'
import ResetPassword from 'features/auth/reset-password/ResetPassword'
import Register from 'features/auth/register/Register'
import ProtectedAdminRoute from './ProtectedAdminRoute'
import LdapManagement from 'features/settings/system/ldap-management/LdapManagement'
import RolesManagement from 'features/settings/system/role-management/RolesManagement'
import PasswordManagement from 'features/settings/system/password-management/PasswordManagement'
import MailManagement from 'features/settings/system/mail-management/MailManagement'
import SystemManagement from 'features/settings/system/systemManagement/SystemManagement'
import UserManagement from 'features/settings/management/user-managment/UserManagement'
import GroupManagement from 'features/settings/management/group-management/GroupManagement'
import ChannelManagement from 'features/settings/management/channel-management/ChannelManagement'
import NewsfeedManagement from 'features/admin-panel/management/newsfeed-management/NewsfeedManagement'
import NewsFeedLayout from 'features/news-feed/NewsFeedLayout'
import NewsFeed from 'features/news-feed/NewsFeed'
import PostDetail from 'features/news-feed/post-detail/PostDetail'
import InitialSetupForm from 'features/init'
import RolesUserManagement from 'features/settings/system/role-management/RolesUserManagement'
import RolePermissionManagement from 'features/settings/system/role-management/RolePermissionManagement'
import RoleMessagingManagement from 'features/settings/system/role-management/RoleMessagingManagement'
import MobileRedirectedPage from 'features/redirect-page/mobile'
import { isMobile, isTablet, isSmartTV } from 'react-device-detect'
import AdminPanel from 'features/admin-panel/AdminPanel'
import Content from 'features/admin-panel/components/Content'
import  AdminSystemSettings  from 'features/admin-panel/settings/system-settings/SystemSettings'
import AdminUserManagement from 'features/admin-panel/management/user-management/UserManagement'
import TeamManagement from 'features/admin-panel/management/team-management/TeamManagement'
import AdminChannelManagement from 'features/admin-panel/management/channel-management/ChannelManagement'
import AdminNotificationSettings from 'features/admin-panel/notification/NotificationSettings'
import AdminLDAPSettings from 'features/admin-panel/settings/ldap-settings/LDAPSettings'
import AdminPasswordSettings from 'features/admin-panel/settings/password-settings/PasswordSettings'
import AdminRoleSettings from 'features/admin-panel/settings/role-settings/RoleSettings'
import AdminMobileSettings from 'features/admin-panel/settings/mobile-web-settings/MobileWebSettings'
import AdminMailProviderSettings from 'features/admin-panel/settings/mail-settings/MailProviderSettings'
import AdminDashboard from 'features/admin-panel/dashboard/Dashboard'
import PrivacyTextSettings from 'features/admin-panel/settings/privacy-text-settings/PrivacyTextSettings'
import FileExtensionSettings from 'features/admin-panel/settings/file-extension-settings/FileExtensionSettings'
import NewsfeedTeamManagement from 'features/admin-panel/management/newsfeed-management/NewsfeedTeamManagement'
import AdminMobileAppSettings from 'features/admin-panel/mobile-app-settings/MobileAppSettings'
import InAppBrowserSettings from 'features/admin-panel/mobile-app-settings/in-app-browser-settings/InAppBrowserSettings'
import SuccessPassword from 'features/auth/success-password/SuccessPassword'
import TeamsCallMock from 'features/video-conference/vc'
import Threads from 'features/messages/Threads'
import ThreadsConversation from 'features/messages/ThreadsConversation'
import VideoCallRedirect from '../features/video-conference/VideoCallRedirect'
//import ForgetPassword from 'features/auth/forget-password/ForgetPassword'

const Index = () => {
  return isMobile || isTablet || isSmartTV ? (
    <Routes>
      {/* <Route path="forget-password" element={<ForgetPassword />}></Route> */}
      <Route path="reset-password/:inviteId" element={<ResetPassword />} />
      <Route path="success-password" element={<SuccessPassword />}></Route>
      <Route path="mobile-redirect" element={<MobileRedirectedPage />}></Route>

      <Route path="*" element={<Navigate to="/mobile-redirect" />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/" element={<ProtectedMainLayout />}>
        <Route path="news-feed" element={<NewsFeedLayout />}>
          <Route index element={<NewsFeed />} />
          <Route path=":postId" element={<PostDetail />} />
        </Route>
        <Route path="news-feed/:postId" element={<NewsFeedLayout />}></Route>
        <Route path="channels" element={<Channels />}>
          <Route path=":channelId" element={<ChannelsConversation />} />
        </Route>

        <Route
          path="system-settings"
          element={
            <ProtectedAdminRoute>
              <SystemSettings />
            </ProtectedAdminRoute>
          }
        >
          <Route
            path="server-domain-management"
            element={
              <ProtectedAdminRoute>
                <SystemManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="ldap-management"
            element={
              <ProtectedAdminRoute>
                <LdapManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="role-management"
            element={
              <ProtectedAdminRoute>
                <RolesManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="role-management/users/:roleId"
            element={
              <ProtectedAdminRoute>
                <RolesUserManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="role-management/permissions/:roleId"
            element={
              <ProtectedAdminRoute>
                <RolePermissionManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="role-management/messaging/:roleId"
            element={
              <ProtectedAdminRoute>
                <RoleMessagingManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="password-management"
            element={
              <ProtectedAdminRoute>
                <PasswordManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="mail-management"
            element={
              <ProtectedAdminRoute>
                <MailManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="user-management"
            element={
              <ProtectedAdminRoute>
                <UserManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="group-management"
            element={
              <ProtectedAdminRoute>
                <GroupManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="channel-management"
            element={
              <ProtectedAdminRoute>
                <ChannelManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="newsfeed-management"
            element={
              <ProtectedAdminRoute>
                <NewsfeedManagement />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="dashboard"
            element={
              <ProtectedAdminRoute>
                <Dashboard />
              </ProtectedAdminRoute>
            }
          />
        </Route>
        <Route path="messages" element={<Messages />}>
          <Route path=":roomId" element={<Conversation />} />
        </Route>
        {/* <Route path="/threads" element={<Threads />}>
          <Route index element={<></>} />
          <Route path=":threadId" element={<ThreadsConversation />} />
        </Route> */}

        <Route path="video-call" element={<VideoCall />} />

        <Route path={'join/:meetingId/:participantToken'} element={<VideoCallRedirect />} />
        <Route path="video-conference" element={<TeamsCallMock />}>
          <Route path=":roomId/:meetingId/:participantToken" element={<Conversation />} />
        </Route>

        {/* <Route path="live-stream" element={<LiveStream />} /> */}
        <Route path="*" element={<Navigate to="/news-feed" />} />
      </Route>

      {/* Admin Panel */}
      <Route
        path="admin-panel"
        element={
          <ProtectedAdminRoute>
            <AdminPanel />
          </ProtectedAdminRoute>
        }
      >
        <Route path="dashboard" element={<Content activeMenuItem="dashboard" />}>
          <Route path="general-view" element={<AdminDashboard />} />
          <Route path="statistics" element={<div>İstatistikler İçeriği</div>} />
          <Route path="reports" element={<div>Raporlar İçeriği</div>} />
        </Route>
        <Route path="settings" element={<Content activeMenuItem="settings" />}>
          <Route path="system" element={<AdminSystemSettings />} />
          <Route path="password" element={<AdminPasswordSettings />} />
          <Route path="mail-provider" element={<AdminMailProviderSettings />} />
          <Route path="ldap" element={<AdminLDAPSettings />} />
          <Route path="role" element={<AdminRoleSettings />} />
          <Route path="mobile-web" element={<AdminMobileSettings />} />
          <Route path="privacy-text" element={<PrivacyTextSettings />} />
          <Route path="file-extension" element={<FileExtensionSettings />} />
        </Route>
        <Route path="management" element={<Content activeMenuItem="management" />}>
          <Route path="user" element={<AdminUserManagement />} />
          <Route path="team" element={<TeamManagement />} />
          <Route path="channel" element={<AdminChannelManagement />} />
          <Route path="newsfeed" element={<NewsfeedManagement />} />
          <Route path="share" element={<NewsfeedTeamManagement />} />
        </Route>
        <Route path="mobile" element={<Content activeMenuItem="mobile" />}>
          <Route path="mobile-apps" element={<AdminMobileAppSettings />} />
          <Route path="in-app-browser" element={<InAppBrowserSettings />} />
        </Route>
        <Route path="notification" element={<Content activeMenuItem="notification" />}>
          <Route path="" element={<AdminNotificationSettings />} />
          <Route path="message-notification" element={<div>Mesaj Bildirimleri</div>} />
          <Route path="newsfeed-notification" element={<div>Haber Bildirimleri</div>} />
        </Route>
        {/* Eğer doğrudan /admin-panel yoluna gidilirse varsayılan olarak pano'ya yönlendir */}
        <Route path="" element={<Navigate to="/admin-panel/dashboard" />} />
      </Route>

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/init" element={<InitialSetupForm />} />
      <Route path="/reset-password/:inviteId" element={<ResetPassword />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  )
}

export default Index
